import { useState } from "react";
import { X, ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../data/content";

export const Portfolio = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="work" data-testid="portfolio-section" className="py-24 px-4 sm:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <p className="font-mono2 text-xs tracking-[0.35em] text-amber-500/90 mb-4">SELECTED CREDITS</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-wide text-zinc-50 mb-12">
          WORK THAT <span className="text-stroke">NEVER HAPPENED</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROJECTS.map((p, i) => (
            <button key={p.id} data-testid={i === 0 ? "portfolio-modal-trigger" : `portfolio-card-${p.id}`}
              onClick={() => setActive(p)}
              className={`portfolio-card-item group relative overflow-hidden border border-white/10 text-left ${i % 5 === 0 ? "sm:col-span-2" : ""} h-72 sm:h-80`}>
              {p.poster && <img src={p.image} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover blur-2xl opacity-40 scale-110" />}
              <img src={p.image} alt={p.title}
                className={`absolute inset-0 w-full h-full opacity-60 group-hover:opacity-90 group-hover:scale-105 transition duration-700 ${p.poster ? "object-contain" : "object-cover"}`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-6">
                <div className="flex items-center justify-between">
                  <span className="font-mono2 text-[10px] tracking-[0.3em] text-amber-500">{p.client}{p.year ? ` — ${p.year}` : ""}</span>
                  <ArrowUpRight className="w-5 h-5 text-zinc-400 group-hover:text-amber-500 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
                </div>
                <h3 className="font-display text-3xl tracking-wide text-zinc-50 mt-2">{p.title}</h3>
                <div className="flex flex-wrap gap-2 mt-2">
                  {p.tags.map((t) => (
                    <span key={t} className="font-mono2 text-[9px] tracking-[0.2em] border border-white/20 px-2 py-0.5 text-zinc-300 uppercase">{t}</span>
                  ))}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div data-testid="portfolio-case-study-modal" className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={() => setActive(null)}>
          <div className="relative w-full max-w-3xl bg-[#0E0E12] border border-amber-500/40 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <img src={active.image} alt={active.title} className={`w-full aspect-video ${active.poster ? "object-contain bg-black" : "object-cover"}`} />
            <button data-testid="portfolio-modal-close-btn" onClick={() => setActive(null)}
              className="absolute top-4 right-4 bg-black/70 p-2 text-zinc-300 hover:text-amber-500 transition-colors">
              <X className="w-5 h-5" />
            </button>
            <div className="p-6 sm:p-10">
              <p className="font-mono2 text-xs tracking-[0.3em] text-amber-500 mb-2">{active.client}{active.year ? ` — ${active.year}` : ""}</p>
              <h3 className="font-display text-4xl sm:text-5xl tracking-wide text-zinc-50">{active.title}</h3>
              <p className="mt-5 text-zinc-300 leading-relaxed">{active.description}</p>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {active.scope.map((s) => (
                  <div key={s} className="border border-white/10 bg-white/[0.03] px-4 py-3 font-mono2 text-[11px] tracking-[0.15em] text-zinc-300 uppercase">
                    <span className="text-amber-500 mr-2">◆</span>{s}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
